import axios from "axios";
import { SET_ERROR, UNRECORDED_ORDERS, PURCHASE_ORDER, PURCHASE_ORDERS } from "../../types"

export const getPurchaseOrders = (params) => {

    return async (dispatch) => {
        await axios.get("/api/purchase-orders/get-orders", {
            params
        }).then(response => {
            dispatch({
                type: PURCHASE_ORDERS,
                payload: response.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
}

export const unrecordedOrders = () => {
    return async dispatch => {
        await axios.get('/api/purchase-orders/unrecorded-orders').then(res => {
            dispatch({
                type: UNRECORDED_ORDERS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const savePurchaseOrder = payload => {
    return async dispatch => {
        await axios.post('/api/purchase-orders/save-purchase-order', payload).then(res => {
            dispatch({
                type: PURCHASE_ORDER,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
}